export default __webpack_public_path__ + "static/media/logo_white.07813521.png";